import ReactGA from 'react-ga4';
import Cookies from 'js-cookie';

const GA_TRACKING_ID = 'G-Z9D7XE1TEJ';

export const initGA = (userId = null) => {
  const hasConsent = Cookies.get('ga_consent');
  
  if (hasConsent === 'true') {
    ReactGA.initialize(GA_TRACKING_ID);
    if (userId) {
      ReactGA.set({ userId });
    }
  }
};

export const logPageView = () => {
  const hasConsent = Cookies.get('ga_consent');
  if (hasConsent === 'true') {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }
};

export const logEvent = (category, action, label, userId = null) => {
  const hasConsent = Cookies.get('ga_consent');
  if (hasConsent === 'true') {
    const eventParams = {
      category: category,
      action: action,
      label: label,
    };
    
    if (userId) {
      eventParams.user_id = userId;
    }
    
    ReactGA.event(eventParams);
  }
};

// window.gtag 함수를 직접 사용할 수 있도록 타입 체크
export const gtag = (...args) => {
  const hasConsent = Cookies.get('ga_consent');
  if (hasConsent === 'true' && window.gtag) {
    window.gtag(...args);
  }
};

// 사용자 정보 설정
export const setUserProperties = (userProperties) => {
  const hasConsent = Cookies.get('ga_consent');
  if (hasConsent === 'true') {
    ReactGA.set(userProperties);
  }
};

// 상품 조회 이벤트
export const viewItem = (item) => {
  window.gtag('event', 'view_item', {
    currency: 'USD',
    value: item.price,
    items: [{
      item_id: item.id,
      item_name: item.name,
      price: item.price,
      currency: 'USD'
    }]
  });
};

// 장바구니 추가 이벤트
export const addToCart = (item) => {
  window.gtag('event', 'add_to_cart', {
    currency: 'USD',
    value: item.price,
    items: [{
      item_id: item.id,
      item_name: item.name,
      price: item.price,
      currency: 'USD'
    }]
  });
};

// 결제 시작 이벤트
export const beginCheckout = (items, total) => {
  window.gtag('event', 'begin_checkout', {
    currency: 'USD',
    value: total,
    items: items.map(item => ({
      item_id: item.id,
      item_name: item.name,
      price: item.price,
      currency: 'USD'
    }))
  });
};

// 구매 완료 이벤트
export const purchase = (transaction) => {
  window.gtag('event', 'purchase', {
    transaction_id: transaction.id,
    value: transaction.total,
    currency: 'USD',
    tax: transaction.tax,
    items: transaction.items.map(item => ({
      item_id: item.id,
      item_name: item.name,
      price: item.price,
      currency: 'USD'
    }))
  });
};